(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

var toggleButton = document.getElementById("toggleButton");

toggleButton.addEventListener("click", function() {
    var ariaExpanded = this.getAttribute("aria-expanded");
    this.setAttribute("aria-expanded", ariaExpanded === "true" ? "false" : "true");
});

/* Scroll code on budle product page  */
let scrollInterval;
function scrollTest() {
    let button = document.querySelector('.th_pb_cb_ms_next_btn');
    if (button && !button.classList.contains('th_pb_bb_disabled_next_btn')) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        clearInterval(scrollInterval);
        scrollInterval = setInterval(scrollAgain, 500);
    }
}
  
scrollInterval = setInterval(scrollTest, 500);
function scrollAgain() {
    let button = document.querySelector('.th_pb_cb_ms_next_btn');
    if (button && button.classList.contains('th_pb_bb_disabled_next_btn')) {
        clearInterval(scrollInterval);
        scrollInterval = setInterval(scrollTest, 500);
    }
}

/* End Scroll code on budle product page  */
  








  
  




  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card"]) return;
  try {
    
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);






















  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redeem-products"] && !window.DesignMode) return;
  try {
    
	$(document).ready(function(){
			$('.refer-cta').on('click', function(e) {
              e.preventDefault();
              $('.lion-rule-item--referral').find('button.lion-action-button').trigger('click');
            });

	function rearrange() {
		$('section.refer-friend').remove().insertBefore('.lion-redeem');
          var productNames = [];
          var products = [];
          $('.redeem-for-products .lion-reward-item').each(function(){

              var preProductName = $(this).find('.lion-reward-item__title').html().replace(/\s+/g, "-");
              var productName = preProductName.replace('---', "-");
    		  console.log(productName);
			  if(productName.length > 0) {
              	productNames.push(productName);
			  }

              var pointValue = $(this).find('span.value').text();
              var pointText = $(this).find('span.text').text();
			  var buttonText = $(this).find('.lion-reward-item__redeem-button-text').text();
              console.log(productName);
              jQuery.getJSON('/products/'+productName+'.js', function(product) {
                  products.push(product);
			  if(buttonText.length > 0) {
				 
				$('ul.slider').append('<li class="grid__item slider__slide"> <div class="card-wrapper"> <div class="card-information"> <div class="card-information__wrapper"> <span class="caption-large light"></span> </div> </div> <div class="card card--product  card--outline" tabindex="-1"> <div class="card__inner"><div> <a href="#'+product.title+'"> <div class="media media--transparent media--portrait media--hover-effect"> <img class="product-img" data-product-title="'+product.title+'" srcset="'+product.featured_image+'" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" loading="lazy" class="motion-reduce" width="1200" height="1500"> </div> </a> </div> </div> </div> <h3 class="card-information__text h5"> <a class="product-title" href="#'+product.title+'"><span>'+product.title+'</span></a></h3><p>'+pointValue+' '+ pointText+'</p><button data-anchor="'+product.title+'" class="product-title-trigger">'+buttonText+'</button> </div> </li>');
				
				} else {
	$('ul.slider').append('<li class="grid__item slider__slide"> <div class="card-wrapper"> <div class="card-information"> <div class="card-information__wrapper"> <span class="caption-large light"></span> </div> </div> <div class="card card--product  card--outline" tabindex="-1"> <div class="card__inner"><div> <a href="#'+product.title+'"> <div class="media media--transparent media--portrait media--hover-effect"> <img class="product-img" data-product-title="'+product.title+'" srcset="'+product.featured_image+'" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" loading="lazy" class="motion-reduce" width="1200" height="1500"> </div> </a> </div> </div> </div> <h3 class="card-information__text h5"> <a class="product-title" href="#'+product.title+'"><span>'+product.title+'</span></a></h3><p>'+pointValue+' '+ pointText+'</p> </div> </li>');
				
				}
              });
          });

          $(document).on('click', '.product-title-trigger',  function(e) {
            e.preventDefault();
            var productTitle = $(this).data('anchor').replace(/ /g,''); 
            $('.lion-reward-item__title').each(function() {
              var rewardTitle = $(this).text().replace(/ /g,'');
              if( productTitle == rewardTitle ) {
                $(this).parents('.lion-reward-item').find('button').click();
              }
            });
          });

          $(document).on('click', '.product-img',  function(e) {
            e.preventDefault();
            var productTitle = $(this).data('product-title').replace(/ /g,'');

            $('.lion-reward-item__title').each(function() {
              var rewardTitle = $(this).text().replace(/ /g,'');
              if( productTitle == rewardTitle ) {
                $(this).parents('.lion-reward-item').find('button').click();
              }
            });
            
            
          });


<!--           $(document).find('.lion-tier-compare__header-cell--tier-0').prepend('<img src="https://cdn.shopify.com/s/files/1/0102/5785/8615/t/54/assets/sunny.png?v=1653600083"/>').append('<span class="cost">$0-$149.99</span>'); -->
<!--           $(document).find('.lion-tier-compare__header-cell--tier-1').prepend('<img src="https://cdn.shopify.com/s/files/1/0102/5785/8615/t/54/assets/Monsoon_sunset.png?v=1653599952">').append('<span class="cost">$150-$299.99</span>'); -->
<!--           $(document).find('.lion-tier-compare__header-cell--tier-2').prepend('<img src="https://cdn.shopify.com/s/files/1/0102/5785/8615/t/54/assets/sunniest.png?v=1653600098"/>').append('<span class="cost">$300+</span>'); -->
	      $(document).find('.lion-account-history').detach().insertAfter('div[data-lion-tier-rewards-compare]');
		  $(document).find('.lion-history-table').wrap( "<div id='loyaltylion'></div>" );
		  
		  $('.lion-rule-item--177793').find('button').addClass('lion-action-button--disabled').text('COMING SOON');
		  $('.lion-integrated-page--guest .lion-header__join-buttons').detach().appendTo('.lion-header__join-today');
		  $('.reward-steps').detach().insertAfter('.lion-header');

            var currentTier = $('.lion-tier-box--current').find('.lion-tier-box__title').text();

            $('.lion-header__your-points').prepend('<p class="tier">Tier: '+currentTier+'</p>');

			}
	


	setTimeout(rearrange, 2000);



	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refer-friend"] && !window.DesignMode) return;
  try {
    
	$(document).ready(function(){
			$('.refer-cta').on('click', function(e) {
              e.preventDefault();
              $('.lion-rule-item--referral').find('button.lion-action-button').trigger('click');
            });

	function rearrange() {
		$('section.refer-friend').remove().insertBefore('.lion-redeem');
        <!-- REDEEM FOR DISCOUNTS SECTION	 -->
        $('.lion-redeem__heading h3').text('Redeem for Discounts');
        $('.lion-redeem__heading').append('<p>It’s simple! Redeem your points for discounts on all your desert-derived favorites.</p>');
		$('.static-rewards-list').detach().insertAfter('.lion-redeem__heading');


		$('.lion-rule-item--signup').find('.lion-rule-item__actions').append('<button class="lion-action-button lion-action-button--tile lion-action-button--disabled lion-action-button--completed"><span class="lion-rule-item__completed" data-i18n-key="ui.general.completed">Completed</span></button>');

		$(document).on('click', '.refer-cta', function() {
			$('.lion-rule-item--173360').find('button').click();
		});

	}

	setTimeout(rearrange, 5000);



	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-faq"] && !window.DesignMode) return;
  try {
    
	$(document).ready(function() {
      $('.reward-faqs-title').on('click', function() {
			$(this).parent('.reward-faq').find('.reward-faqs-description').slideToggle();
			$(this).parent('.reward-faq').toggleClass('faq-active');
			
	});

	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker-banner"] && !window.DesignMode) return;
  try {
    
      Marquee3k.init();
    
  } catch(e) { console.error(e); }
})();
})();
